import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './MobileNotSupportedLayout.module.scss';

import ErrorMobile from '../../../../assets/image/error-mobile.svg';

const MobileNotSupportedLayout = () => {
  return (
    <>
      {/* Desktop content (all authenticated routes render here) */}
      <div className={styles.desktopOnly}>
        <Outlet />
      </div>

      {/* Mobile not supported (same UI as before) */}
      <div className={styles['mobile-layout']}>
        <img
          src={ErrorMobile}
          alt='Mobile Error'
          className={styles['error-mobile-img']}
        />
        <div className={styles['error-mobile-text']}>
          <span className={styles['error-mobile-title']}>
            Mobile not supported
          </span>
          <span className={styles['error-mobile-sub']}>
            For the full AiDucator experience, please transfer to desktop to
            continue work.
          </span>
        </div>
      </div>
    </>
  );
};

export default MobileNotSupportedLayout;
